import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom'
import Home from './pages/Home.js'
import Patient from './pages/Patient.js'
import CurrentPatients from './pages/CurrentPatients.js'
import theme from './theme.js'
import MuiPickersUtilsProvider from 'material-ui-pickers/MuiPickersUtilsProvider'
import MomentUtils from '@date-io/moment'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { withStyles } from '@material-ui/core/styles'

const styles = {
  page: {
    height: '100%'
  }
}

class App extends Component {
  render () {
    const { classes } = this.props
    return (
      <Router>
        <MuiThemeProvider theme={theme}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <div className={classes.page}>
              <Route path="/" component={Home}/>
              <Route exact path="/patients" component={CurrentPatients}/>
              <Route path="/patients/:id/:dataSection?" component={Patient}/>
            </div>
          </MuiPickersUtilsProvider>
        </MuiThemeProvider>
      </Router>
    )
  }
}

export default withStyles(styles)(App)



// WEBPACK FOOTER //
// ./src/App.js